import { TicketListItemDto } from "@megaron/support-contracts";

const threeDaysInMs = 3 * 24 * 60 * 60 * 1000;

export const isSupportTicketAgedOpen = (item: TicketListItemDto): boolean => {
  const status = item.status.toLowerCase();
  if (status !== "open") {
    return false;
  }

  const createdAtMs = new Date(item.createdAt).getTime();
  if (Number.isNaN(createdAtMs)) {
    return false;
  }

  return Date.now() - createdAtMs >= threeDaysInMs;
};
